import $ from 'jquery';

let jqQuestionButtons;
let jqAnswerContainers;

/**
 * Set the active question to match the hash fragment.
 *
 * @param {HTMLDivElement} faqsContainer
 */
export default function(faqsContainer: HTMLDivElement): void {

    jqAnswerContainers = $('.js-faq-answer');

    if(!jqAnswerContainers.length) {
        return;
    }

    jqQuestionButtons = $('.js-faq-button');

    if(!jqQuestionButtons.length) {
        return;
    }

    $(window).on('hashchange', hashChangeHandler);
    jqQuestionButtons.on('click', questionClickHandler);

    if(!location.hash.length) {
        jqQuestionButtons.slice(1).attr('aria-expanded', 'false');
        jqAnswerContainers.slice(1).removeClass('show');
        return;
    }

    hashChangeHandler(null);
}

/**
 * Handle question click events, update the URL hash
 *
 */
function questionClickHandler(event) {

    location.hash = $(event.target).attr('data-target') as string;
}

/**
 * Handle hash changes & update the accordian
 *
 */
function hashChangeHandler(event) {

    jqQuestionButtons.each(function(i, el) {

        const jqQuestionButton = $(el);
        jqQuestionButton.attr('aria-expanded', 'false');

        const targetId = jqQuestionButton.attr('data-target');

        if(targetId === location.hash) {

            jqQuestionButton.attr('aria-expanded', 'true');

            const jqAnswerContainer = $('.js-faq-answer' + targetId);

            if(!jqAnswerContainer.length) {
                return;
            }

            jqAnswerContainers.removeClass('show');
            jqAnswerContainer.addClass('show');
        }
    });
}
